import { render, staticRenderFns } from "./DoughnutChartComplete.vue?vue&type=template&id=5cbb950c&scoped=true&"
import script from "./DoughnutChartComplete.vue?vue&type=script&lang=js&"
export * from "./DoughnutChartComplete.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutChartComplete.vue?vue&type=style&index=0&id=5cbb950c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb950c",
  null
  
)

export default component.exports